module.exports = function() {
  return new Worker("/" + "babel-transpiler.dfa08bb6.worker.js");
};